import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from '@mui/material/Container';

const Footer = (props) => {
    return (
        <Box component={'footer'} sx={{my: 2}}>
            <Container maxWidth={false}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary"
                                    align="left" {...props}>
                            {'Copyright © '}
                            <Link color="inherit" href="https://visua.com/">
                                Visua
                            </Link>{' '}
                            {new Date().getFullYear()}
                            {'.'}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Footer;